const { VITE_CONVERSATIONS_API } = import.meta.env;

/** The credentials the notification inbox signs in to Courier with. `user_id` is
 *  the id notifications are addressed to, so it must be passed to Courier as is.
 *  `expires_at` is an ISO timestamp; Courier never refreshes the token itself. */
export interface NotificationsToken {
  user_id: string;
  token: string;
  expires_at: string;
}

export const notificationsTokenPath = `${VITE_CONVERSATIONS_API}/notifications/token`;

export const notificationPreferencesPath = `${VITE_CONVERSATIONS_API}/notifications/preferences`;

/** `in-app` is the inbox only, `email` is email only, `none` opts out of all notifications. */
export type NotificationDelivery = "in-app" | "email" | "both" | "none";

export interface NotificationPreferences {
  delivery: NotificationDelivery;
}
